export default "__VITE_ASSET__DUD4H_rr__"